export default __webpack_public_path__ + "static/media/arrow-down.7fd9cd1b.svg";